export default class MfSelectModalController {
	/* @ngInject */
	/**
	 * @param {import('angular').IScope} $scope
	 * @param {import('angular').ITimeoutService} $timeout
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/ktranslate').KTranslate} KTranslate
	 * @param {any[]} path
	 */
	constructor(
		$scope,
		$timeout,
		$uibModalInstance,
		KTranslate,
		path,
	) {
		this.node = undefined;
		this.path = path;
		this.tree = {};
		this.treeIndex = 0;

		let index = 0;
		const recTree = (/** @type {any[]} */ array, /** @type {any} */ tree) => {
			tree.index = index++;
			tree.item = array.shift();
			tree.child = array.length > 0 ? recTree(array, {}) : null;
			return tree;
		};

		this.tree = recTree([...path], {});

		this.$uibModalInstance = $uibModalInstance;
		if (this.path && this.path.length > 0) {
			this.showTree = true;
			(async () => {
				this.title = this.path.at(-1).name
					|| await KTranslate.request($scope, this.path.at(-1).kid);
				$timeout(() => $scope.$apply());
			})();
		}
		else {
			this.showTree = false;
		}
	}

	cancel() {
		return this.$uibModalInstance.dismiss('cancel');
	}

	submit() {
		return this.$uibModalInstance.close(this.path);
	}

	deleteNode() {
		this.path.length = 0;
	}

	/**
	 * @param {import('@knitiv/api-client-javascript').AutocompleteItem
	 *   & {linker_kid: import('@knitiv/api-client-javascript').LinkerKNode}} item
	 */
	selectNode(item) {
		this.path.length = 0;
		this.path.push({
			isa:        item.isa,
			kid:        item.kid,
			linker_kid: item.linker_kid,
			name:       item.name,
		});
	}
}
